type HorizontalTabContainerProps = {
  children: React.ReactNode
}

const HorizontalTabContainer: React.FC<HorizontalTabContainerProps> = ({ children }) => (
  <div className="pb-2">{children}</div>
)

export default HorizontalTabContainer
